import {atom} from 'jotai';
import {atomWithHash} from 'jotai-location';
import {atomWithReset} from 'jotai/utils';
import {ContentFilters, PaginationParams} from './types';

// Content filters state
export const contentFiltersAtom = atom<ContentFilters>({
    creator_username: undefined,
    mediaType: undefined,
    topic_id: undefined,
    is_enriched: undefined,
    start_date: undefined,
    end_date: undefined,
    search: undefined,
});

// Content pagination state
export const contentPaginationAtom = atom<PaginationParams>({
    page: 1,
    page_size: 10,
});

// Combined content query parameters
export const contentQueryAtom = atom((get) => ({
    ...get(contentFiltersAtom),
    ...get(contentPaginationAtom),
}));

// Active tab state with URL hash persistence (default to 'content')
export const activeTabAtom = atomWithHash<string>('tab', 'content');

// Modal visibility states
export const enrichModalVisibleAtom = atom<boolean>(false);
export const addCreatorModalVisibleAtom = atom<boolean>(false);
export const addTopicModalVisibleAtom = atom<boolean>(false);

// Selected items for operations
export const selectedContentIdAtom = atomWithReset<string | null>(null);
export const selectedCreatorIdAtom = atomWithReset<string | null>(null);
export const selectedTopicIdAtom = atomWithReset<string | null>(null);

// Loading states
export const scrapingLoadingAtom = atom<boolean>(false);

// Search states for selects
export const creatorSearchAtom = atom<string>('');
export const topicSearchAtom = atom<string>('');